const findNext = ({
  length,
  start,
  isValidIndex
}) => {
  for (let i = start; i < length; i++) {
    if (isValidIndex(i)) return i;
  }
  return undefined;
};

/**
 * Find the next valid index.
 * @param IndexProps
 * @returns valid index or undefined, if there's no valid index.
 */
export const findNextIndex = ({
  wrap,
  ...props
}) => findNext(props) ?? (wrap ? findNext({
  ...props,
  start: 0,
  length: props.start
}) : undefined);
const findPrevious = ({
  start,
  isValidIndex
}) => {
  for (let i = start; i >= 0; i--) {
    if (isValidIndex(i)) return i;
  }
  return undefined;
};

/**
 * Find the previous valid index.
 * @param IndexProps
 * @returns valid index or undefined, if there's no valid index.
 */
export const findPreviousIndex = ({
  wrap,
  ...props
}) => findPrevious(props) ?? (wrap ? findPrevious({
  ...props,
  start: props.length - 1
}) : undefined);

/**
 * Find the next valid index after a page or end of the length.
 * @param PageIndexProps
 * @returns valid index or undefined, if there's no valid index.
 */
export const findNextPageIndex = ({
  length,
  start,
  isValidIndex,
  pageSize
}) => {
  let lastValidIndex;
  for (let i = start; i < length; i++) {
    if (isValidIndex(i)) {
      pageSize--;
      lastValidIndex = i;
    }
    if (pageSize === 0) return i;
  }
  return lastValidIndex ?? undefined;
};

/**
 * Find the previous valid index after a page or beginging of the length.
 * @param PageIndexProps
 * @returns valid index or undefined, if there's no valid index.
 */
export const findPreviousPageIndex = ({
  start,
  isValidIndex,
  pageSize
}) => {
  let lastValidIndex;
  for (let i = start; i >= 0; i--) {
    if (isValidIndex(i)) {
      pageSize--;
      lastValidIndex = i;
    }
    if (pageSize === 0) return i;
  }
  return lastValidIndex ?? undefined;
};
//# sourceMappingURL=findIndex.js.map